<template>
    <div>
        <div class="wptop">
        <div class="fxwidth wpheader">
            <div class="hdback" @click="goBack"></div>
            <div class="hdtitle">我的关注</div>
        </div>
        <div class="headerhd"></div>
        </div>

        <div class="mywrap">
            <div class="mylft"><Left/></div>
            <div class="myrht">
                <div class="mytit">我的关注</div>

        <div class="skeletonbx" v-if="list.length === 0 && init === true">
            <van-skeleton row="5"></van-skeleton>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loadmore"
                  :immediate-check="false"
                  :finished="finished"
                  :finished-text="list.length>0?'没有更多内容了':''"
                  :error.sync="error"
                  :error-text="list.length>0?'读取失败':''"
                  @load="loadMore">
            <ul class="follow-expert-list" v-if="list.length > 0">
                <li v-for="(c,i) in list" :key="i">
                    <router-link :to="'/member/'+c.id" class="follow-expert-card">
                        <div class="follow-expert-profile">
                        <div class="img">
                            <img :src="c.portrait" :onerror="defimg" v-if="c.portrait">
                            <img :src="defimg" v-else>
                        </div>
                        <div class="cone">
                            <div class="name">{{c.name}} <em>认证专家</em></div>
                            <div class="intro" v-if="c.intro">{{c.intro}}</div>
                            <div class="intro" v-else>专注足球赛事数据、阵容变化与战术研究</div>
                        </div>
                        </div>
                        <div class="follow-expert-metrics">
                            <span><b>{{c.winrate || 0}}%</b><small>7天胜率</small></span>
                            <span><b>{{c.roi || 0}}%</b><small>回报率</small></span>
                            <span><b>{{c.stability || 0}}%</b><small>稳定性</small></span>
                            <span><b>{{c.recommend_count || 0}}</b><small>历史分析</small></span>
                            <span><b>{{c.hot_sales || 0}}</b><small>热销场次</small></span>
                            <span><b>{{c.fans_count || 0}}</b><small>关注人数</small></span>
                        </div>
                        <div class="follow-expert-home">查看专家主页 <b>→</b></div>
                    </router-link>
                    <div class="rel">
                        <span v-if="c.relation == 0" @click="addFollow(i)"><em>+</em>关注</span>
                        <span v-else-if="c.relation == 1" class="en" @click="unAddFollow(i)">已关注</span>
                        <span v-else-if="c.relation == 2" class="en" @click="unAddFollow(i)">互相关注</span>
                    </div>
                </li>
            </ul>
        </van-list>
        </van-pull-refresh>
                <div v-if="list.length === 0 && init === false"  class="list-none">没有记录~</div>

            </div>
        </div>

    </div>
</template>

<script>
    import defPortrait from "../../assets/images/default-analyst-v3.jpg"
    import Left from "./left"
    export default {
        name: "member",
        components: {Left},
        data() {
            return {
                uid: null,
                list: [],
                init: true,
                loadmore: false, //是否在加载更多，当滚动到底部时自动设置为true(不需手动设置)，每次加载完都得手动设置为false，
                loadmore_error: false,
                finished: false, //是否加载完毕
                isloading: false, //是否正在读取
                error: false,     //是否读取错误，有错误自动设置为true，点击又重新读取更多（自动设置为false）
                refreshing: false,  //是否在下拉刷新
                pageIndex: 1,
                defimg: defPortrait,
                formPath: ''
            }
        },
        created() {
            this.list = []
            this.onRefresh()
        },
        methods: {
            loadMore() {
                let that = this
                if(!that.loadmore_error)
                    that.pageIndex++
                that.getList()
            },
            onRefresh(){
                let that = this
                this.pageIndex = 1
                this.finished = false
                this.loadmore = false
                this.error = false
                that.getList()
            },
            getList(){
                let that = this
                that.loadmore_error = false
                that.$post(that.$api.myfollow,{page: that.pageIndex}).then(function (res) {
                    //console.log(res)
                    let tmplist = res.data.list
                    if(tmplist.length>0) {
                        tmplist.forEach(function (i) {
                            if(i.portrait)
                                i.portrait = that.$api.imgBaseUrl + i.portrait
                        })
                        if(that.refreshing)
                            that.list = tmplist  //如果是下拉刷新则列表重置
                        else
                            that.list = that.list.concat(tmplist)
                        if (res.data.end)
                            that.finished = true
                    }
                    else{
                        that.finished = true
                    }
                }).catch(function () {
                    that.$toast.fail('读取失败')
                    that.error = true
                    that.loadmore_error = true
                }).finally(function () {
                    // console.log('finally')
                    that.init = false
                    that.loadmore = false
                    that.isloading = false
                    that.refreshing = false
                })
            },
            addFollow(index){
                let that = this
                let id = that.list[index].id
                that.$toast.loading()
                that.$post(that.$api.addfollow, {mid: id}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        that.list[index].relation = res.data.relation
                    }
                    else{
                        that.$toast(res.msg)
                    }
                })
            },
            unAddFollow(index){
                let that = this
                let id = that.list[index].id
                that.$toast.loading()
                that.$post(that.$api.unaddfollow, {mid: id}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        that.list[index].relation = res.data.relation
                    }
                    else{
                        that.$toast(res.msg)
                    }
                })
            },
            goBack(){
                //let that = this
                this.$router.push({
                    path: "/my" //that.formPath === '' ?'/':that.formPath
                })
            }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
    .follow-expert-list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;margin:0;padding:24px 28px 30px;list-style:none}
    .follow-expert-list>li{position:relative;min-width:0;overflow:hidden;border:1px solid #d5e4ee;border-radius:12px;background:#fff;box-shadow:0 10px 26px rgba(31,83,113,.07);transition:.2s ease}
    .follow-expert-list>li:hover{transform:translateY(-2px);border-color:#8dc9ec;box-shadow:0 14px 30px rgba(31,83,113,.12)}
    .follow-expert-card{display:block;color:#153d59}
    .follow-expert-profile{display:flex;gap:15px;align-items:flex-start;padding:20px 20px 16px}
    .follow-expert-profile .img{flex:0 0 76px;width:76px;height:76px;padding:3px;border:2px solid #1596df;border-radius:50%;background:#fff;box-shadow:0 7px 18px rgba(21,150,223,.16)}
    .follow-expert-profile .img img{width:100%;height:100%;object-fit:cover;border-radius:50%}
    .follow-expert-profile .cone{min-width:0;flex:1}
    .follow-expert-profile .name{margin:3px 0 8px;color:#092f4c;font-size:20px;font-weight:800}
    .follow-expert-profile .name em{display:inline-block;margin-left:6px;padding:3px 8px;border-radius:5px;color:#765300;background:#ffde78;font-size:11px;font-style:normal;vertical-align:3px}
    .follow-expert-profile .intro{display:-webkit-box;overflow:hidden;color:#607f93;font-size:14px;line-height:1.7;-webkit-box-orient:vertical;-webkit-line-clamp:2}
    .follow-expert-metrics{display:grid;grid-template-columns:repeat(3,1fr);border-top:1px solid #e0eaf0;border-bottom:1px solid #e0eaf0;background:#f5f9fc}
    .follow-expert-metrics span{display:flex;min-height:69px;align-items:center;justify-content:center;flex-direction:column;border-right:1px solid #e0eaf0;border-bottom:1px solid #e0eaf0}
    .follow-expert-metrics span:nth-child(3n){border-right:0}.follow-expert-metrics span:nth-child(n+4){border-bottom:0}
    .follow-expert-metrics b{color:#0b9664;font-size:19px;line-height:1.15}.follow-expert-metrics span:nth-child(2) b{color:#1688d1}.follow-expert-metrics span:nth-child(5) b{color:#c38a0b}
    .follow-expert-metrics small{margin-top:5px;color:#738b9b;font-size:11px}
    .follow-expert-home{height:50px;padding:15px 130px 0 20px;color:#087fc3;font-size:13px;font-weight:800}.follow-expert-home b{margin-left:5px;color:#d19a16}
    .follow-expert-list .rel{position:absolute;right:18px;bottom:10px}.follow-expert-list .rel span{display:flex;min-width:86px;height:32px;align-items:center;justify-content:center;border-radius:6px;color:#fff;background:#10a66e;font-size:13px;cursor:pointer}.follow-expert-list .rel span.en{color:#466678;background:#e6eff4}
    @media(max-width:1100px){.follow-expert-list{grid-template-columns:1fr}}
    @media(max-width:600px){.follow-expert-list{padding:14px;gap:12px}.follow-expert-profile{padding:16px}.follow-expert-profile .img{flex-basis:60px;width:60px;height:60px}.follow-expert-profile .name{font-size:17px}.follow-expert-metrics b{font-size:17px}}
</style>
